<template>
  <div class="modal" @click="close">
    <div class="modal-window bg-light_gray z-10" @click="window" :class="isMobile() ? '' : 'w-96 m-fixed-left'">
      <div v-if="closeModal" class="btn-close">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" @click="closeModal"><g fill-rule="evenodd"><rect height="1" rx=".5" transform="matrix(.70710678 .70710678 -.70710678 .70710678 10.010408 -4.146447)" width="16" x="2.010408" y="9.510408"/><rect height="1" rx=".5" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -4.146447 10.010408)" width="16" x="2.010408" y="9.510408"/></g></svg>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeModal: {
      type: Function
    }
  },
  data () {
    return {
      enableClickEvent: true
    }
  },
  methods: {
    close: function () {
      if (this.closeModal) {
        setTimeout(() => {
          if (this.enableClickEvent) {
            this.closeModal()
          } else {
            this.enableClickEvent = true
          }
        }, 100)
      }
    },
    window: function () {
      this.enableClickEvent = false
    },
    isMobile: function () {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("iphone") != -1 || userAgent.indexOf("android") != -1) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>
